module.exports = __webpack_public_path__ + "img/cliente_att_gris.df6f4a3a.png";